import { APIRepository } from "~/context/Shared/infrastructure/APIRepository";
import { ParameterRepository } from "../domain/ParameterRepository";
import { vectiAppApiUrl } from "~/context/Shared/infrastructure/Config";
import { VectiResult } from "~/context/Shared/domain/VectiResult";

export function createApiParameterRepository(): ParameterRepository {
  return new APIParameterRepository();
}

export class APIParameterRepository
  extends APIRepository
  implements ParameterRepository {
  constructor() {
    super(vectiAppApiUrl());
  }

  async addBankBalance(companyId: string,year: number,bankBalance: number): Promise<VectiResult>{
    console.log("addBankBalance companyId: " + companyId.toString());
    const bankBalanceData = {
      company_uid: companyId.toString(),
      year: year,
      bank_balance: bankBalance
    };
    try {
      const resp = await this.doPost<ParameterData, VectiResult>("/api/parameters/addBankBalance", null, bankBalanceData);
      console.log("addBankBalance resp:" + JSON.stringify(resp));
      return resp;      
      
    } catch (error) {
      console.log("error addBankBalance:" + error);
      return { ok: false, type: "Error: " + error} as VectiResult;
    }
  }
  }
